module.exports = __webpack_public_path__ + "img/groupworks@2x.2a356d89.webp";